import Autocomplete from '../Autocomplete/Autocomplete';
import DoctorItem from './DoctorItem';

export default function DoctorAutocomplete(props) {
	return (
		<Autocomplete
			{...props}
			itemTemplate={props => <DoctorItem {...props} user={props.item} />}
		/>
	);
}
